import { Injectable } from '@angular/core';

import { InlineAddConfig } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class WTaxCodeAddConfigService {
  
  getWTaxCodeConfig(isOutput: boolean = false): InlineAddConfig {
    const fields: any[] = [
      {
        name: 'code',
        label: 'Tax #',
        type: 'text',
        required: true,
        isInstantData: true,
        maxLength: 50,
        placeholder: 'Enter tax code',
        size: 'half'
      },
      {
        name: 'description',
        label: 'Tax Description',
        type: 'text',
        required: false,
        maxLength: 1000,
        placeholder: 'Enter tax description',
        size: 'half'
      },
      {
        name: 'rate',
        label: 'Rate (%)',
        type: 'number',
        required: false,
        placeholder: 'Enter tax rate',
        size: 'half'
      },
      {
        name: 'taxCategory',
        label: 'Tax Category',
        type: 'select',
        required: true,
        options: [
          { value: 1, label: 'Income Tax' },
          { value: 2, label: 'Withholding Tax' },
          { value: 3, label: 'Final Tax' },
          { value: 4, label: 'Withholding VAT' }
        ],
        placeholder: 'Select tax category',
        size: 'half'
      }
    ];

    const hiddenData: any = {
      id: 0,
      isActive: true,
      shouldDisable: false,
      isSystemData: false,
      remark: null
    };

    if (isOutput) {
      fields.push({
        name: 'creditableAccountId',
        label: 'Creditable Account',
        type: 'select',
        required: true,
        options: [], // Options will be loaded dynamically
        placeholder: 'Select Creditable Account',
        size: 'full'
      });
      
      // For Output Tax, Payable Account is not used/hidden
      hiddenData.payableAccount = null;
      hiddenData.payableAccountId = null;
    } else {
      fields.push({
        name: 'payableAccountId',
        label: 'Payable Account',
        type: 'select',
        required: true,
        options: [], // Options will be loaded dynamically
        placeholder: 'Select Payable Account',
        size: 'full'
      });
      
      // For Input Tax, Creditable Account is not used/hidden
      hiddenData.creditableAccount = null;
      hiddenData.creditableAccountId = null;
    }

    return {
      modelType: 'wtaxcode',
      title: 'Withholding Tax Code',
      apiEndpoint: 'api/wtaxcodes/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'wtaxCode': 'code'
      },
      selectionConfig: {
        targetField: 'wtaxCodeId',
        valueField: 'id',
        labelField: 'code'
      },
      hiddenData: hiddenData,
      fields: fields
    };
  }
}
